<template>
  <div >
    <el-drawer @reload="$reloadHandle" title="销售结果跟进" size="40%" :before-close="handleClose" :visible.sync="drawer"
      direction="rtl" append-to-body  custom-class="demo-drawer" ref="drawer" class="details2">

      <div class="demo-drawer__content">



        <template>
          <div>
            <div class="detail-wrap">
              <el-form ref="editForm" :model="formData">
                <div class="d-header">
                  <div class=""  style="padding: 5px;border-bottom: 1px solid #ededed">
                    <i class="el-icon-info" style="color: #00c4b3;" />
                    <!-- {{ dataId ? '查看' : '新增' }}工单 -->
                    工单号：<span style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.orderNo }}</span>
                    <!-- 服务类型 -->
                    <span class="information">{{ formData.serverTypeName}}</span>
                    <!-- 工单状态 -->
                    <span class="information">
                      {{formData.stat == '1'?'登记':formData.stat == '2'?'发布':formData.stat == '5'?'已派网点':formData.stat == '9'?'已派师傅':formData.stat == '13'?'已出发':formData.stat == '17'?'已上门':formData.stat == '20'?'完工暂存':formData.stat == '21'?'已完工':formData.stat == '22'?'网点确定完工':formData.stat == '23'?'中心确定完工':formData.stat == '24'?'总部确定完工':formData.stat == '91'?'待结算':formData.stat == '92'?'结算驳回':formData.stat == '93'?'结算中止':formData.stat == '94'?'已结算':formData.stat == '98'?'挂起':'取消'}}</span>
                    <!-- 紧急度 -->
                    <span class="information" v-if="formData.urger==0">一般</span>
                    <span class="information" v-else-if="formData.urger==1">紧急</span>
                    <span class="information" v-else-if="formData.urger==2">特急</span>
                    <span class="information" v-else>未知</span>
                  </div>
                </div>
                <el-form-item label="是否转化成功:" label-width="100px">
                  <el-radio-group v-model="orderSaleRegister.saleSuccess" @change="changeSaleSuccess">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="销售订单号" v-if="orderSaleRegister.saleSuccess == 1" >
                  <el-input  v-model="orderSaleRegister.saleNumber" autocomplete="off" style="width: 200px !important;"></el-input>
                </el-form-item>
                <el-form-item label="安装工单号" v-if="orderSaleRegister.saleSuccess == 1">
                  <el-input style="width: 200px !important;" type="text" autocomplete="off" v-model="orderSaleRegister.installOrderNo" clearable :readonly="true">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialogFunc"></i>
                  </el-input>
                </el-form-item>
                <el-form-item label="销售转化大类" v-if="orderSaleRegister.saleSuccess == 1">
                  <el-input  v-model="orderSaleRegister.saleBigCategoryName" :readonly="true" autocomplete="off" style="width: 200px !important;"></el-input>
                </el-form-item>
                <el-form-item label="转化产品型号" v-if="orderSaleRegister.saleSuccess == 1">
                  <el-input  v-model="orderSaleRegister.saleItemModel" :readonly="true" autocomplete="off" style="width: 200px !important;"></el-input>
                </el-form-item>
                <el-form-item label="实际销售金额" v-if="orderSaleRegister.saleSuccess == 1">
                  <el-input  v-model="orderSaleRegister.factSaleAmount"  autocomplete="off" style="width: 200px !important;"></el-input>
                </el-form-item>
                <el-form-item label="未转化责任方" label-width="100px" v-if="orderSaleRegister.saleSuccess == 0">
                  <el-radio-group v-model="orderSaleRegister.failSucessObject">
                    <el-radio :label="1">用户原因</el-radio>
                    <el-radio :label="2">店铺原因</el-radio>
                    <el-radio :label="3">服务商原因</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="未转化原因" label-width="100px" v-if="orderSaleRegister.saleSuccess == 0">
                  <el-radio-group v-model="orderSaleRegister.failSucessReason" @change="changeFailSucessReason">
                    <el-radio v-for="item in failSucessReasons"
                              :key="item.id" :label="item.id">
                      {{item.label}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="备注" >
                  <el-input type="textarea"
                            :autosize="{ minRows: 4, maxRows: 8}" v-model="orderSaleRegister.remark" autocomplete="off"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </template>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="doSaleRegister">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 关闭弹窗 -->
    <orderPop v-if="showOrderPop" :visiable.sync="showOrderPop" multi="false" @commit="orderCommit"
              :bigSiteId="formData.bigSiteId" :isOrderSaleRegister="1"/>
  </div>
</template>
<script>
import request from "@/router/axios";
import {dictType, loadDictData} from "@/config/dictType";
import orderPop from "@/views/dialogCommon/radioOrderDialog.vue";
  export default {
    inject: ['reload'],
    name: 'edit',
    props: ['multi','orderId' ],
    components: {
      orderPop

    },
    created(){this.dataId=this.orderId
    },
    data() {
      return {
        show3: false,
        dataId: '',
        form2: {
          desc: '',
          name: "",
        },
        showOrderPop: false,

        drawer: true,
        formData: {
        },
        orderSaleRegister:{
          saleSuccess:1
        },
        srcList: [],
        failSucessReasons:[],
      }
    },
    mounted() {
      this.getData();
      this.getFailSucessReasons();
    },
    methods: {
      changeSaleSuccess(){
        if (this.orderSaleRegister.saleSuccess == 0){
          this.orderSaleRegister.saleNumber =null;
          this.orderSaleRegister.installOrderNo =null;
          this.orderSaleRegister.installOrderId =null;
          this.orderSaleRegister.saleBigCategoryId =null;
          this.orderSaleRegister.saleBigCategoryName =null;
          this.orderSaleRegister.saleItemId =null;
          this.orderSaleRegister.saleItemCode =null;
          this.orderSaleRegister.saleItemName =null;
          this.orderSaleRegister.saleItemModel =null;
          this.orderSaleRegister.factSaleAmount =null;
          this.orderSaleRegister.saleNumber =null;
        }
        if (this.orderSaleRegister.saleSuccess == 1){
          this.orderSaleRegister.failSucessReasonName =null
          this.orderSaleRegister.failSucessReason =null
          this.orderSaleRegister.failSucessObject =null
        }
      },
      changeFailSucessReason(){
        this.failSucessReasons.forEach(item => {
          if (item.id === this.orderSaleRegister.failSucessReason){
            this.orderSaleRegister.failSucessReasonName = item.label;
          }
        })
      },
        getData() {
          //获取对应的工单信息
          request({
            url: '/basic/soOrder/getById',
            method: 'post',
            data: {
              id: this.dataId
            },
            isLoading: true,
            modalStrictly: true,
          }).then(response => {
            this.formData = response.data.data;
            this.orderSaleRegister.orderId = this.dataId;
          })
      },
      getFailSucessReasons(){
        //未转换成功原因
        loadDictData("未转换成功原因").then(res => {
          this.sysDictItemList = []
          res.data.data.forEach(item => {
            this.failSucessReasons.push({
              label: item.label,
              id: item.id
            })
          })
        })
      },
      showPreconditionDialogFunc() {
        this.showOrderPop = true
      },
      // 工单弹窗选中
      orderCommit(row) {
        console.log(row, '弹窗数据')
        this.orderSaleRegister.installOrderNo = row.orderNo
        this.orderSaleRegister.installOrderId = row.orderId
        this.orderSaleRegister.saleBigCategoryId = row.bigCategoryId
        this.orderSaleRegister.saleBigCategoryName = row.bigCategoryName
        this.orderSaleRegister.saleItemId = row.itemId
        this.orderSaleRegister.saleItemCode = row.itemCode
        this.orderSaleRegister.saleItemName = row.itemName
        this.orderSaleRegister.saleItemModel = row.itemModel
      },
      shut() {
        // this.showOrderPop=true
      },
      doSaleRegister() {
        if(this.orderSaleRegister.saleSuccess == 1){
          if(!this.orderSaleRegister.saleNumber){
            this.$message.error("请输入对应销售单号")
            return
          }
          if(!this.orderSaleRegister.installOrderId){
            this.$message.error("请选择对应的安装单号")
            return
          }
          if(!this.orderSaleRegister.factSaleAmount){
            this.$message.error("请输入实际销售金额")
            return
          }
        }
        if(this.orderSaleRegister.saleSuccess == 0){
          if(!this.orderSaleRegister.failSucessObject){
            this.$message.error("请选择未转化责任方")
            return
          }
          if(!this.orderSaleRegister.failSucessReason){
            this.$message.error("请选择未转化成功原因")
            return
          }
        }
        this.$mask.open()

        request({
          url: '/basic/soOrderDesignSaleRegister/doSaleRegister',
          method: 'post',
          data:this.orderSaleRegister,
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if(response.data.type == "success"){
            this.$message({ message:response.data.content,type: 'success'});
            this.drawer = false;
            clearTimeout(this.timer);
            this.$emit('orderSaleRegisterCommit', 1)
          }else{
            this.$message({ message:response.data.content,type: 'warning'});
          }
        })
        this.$mask.close()

      },
      cancelForm() {
        this.drawer = false;
        clearTimeout(this.timer);
        this.$emit('orderSaleRegisterCommit', 0)
      },
      changeReturnType(row){
        let returnName =  this.$refs.returnId.selected.label;
        this.$set(this.formData, 'remark', returnName);
      },
      handleClose() {

        this.drawer = false;
        this.$emit('orderSaleRegisterCommit', 0)
      }
    }
  }
</script>
<style lang="scss" scoped>
.details2{

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }
//   3个标签
.information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }
//   每个分支
.d-item {
  border: 1px solid #ededed;
  padding-bottom: 5px;

  .title b {
    display: inline-block;
    line-height: 20px;
    font-size: 13px;
    font-weight: 600;
    margin-right: 84px;
    vertical-align: middle;
    color: rgb(42, 100, 148);
    position: relative;
    z-index: 2;
    background: rgba(42, 100, 148, 0.16);
    margin-left: 0px;
    margin-bottom: 8px;
    padding-left: 12px;
    padding-right: 14px;
    border-radius: 0px 28px 28px 0px;
}
.table-detail tr {
    margin-bottom: 10px;
    display: block;
th {
    font-weight: 400;
    text-align: right;
    width: 7vw !important;
    font-size: 12px;
    position: relative;
    padding: 0 5px 0 4px;
    color: rgba(86, 86, 86, 0.96);
}
td {
    font-weight: 400;
    // text-align: right;
    width: 10vw !important;
    font-size: 12px;
    position: relative;
    padding: 0 0px 0 4px;
    color: rgba(0, 0, 0,);
}
}}

::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space:nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    right: 20%;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }
  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 12px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }
 ::v-deep  .el-step__title {
    font-size: 13px!important;
    line-height: 38px;
}
}
</style>
